<template>
    <div class="register">
        <el-form class="register-form" :model="registerForm" :rules="registerRules" ref="registerForm" label-width="0px">
            <el-tabs  v-model="activeName">
                <el-tab-pane  label="重置密码" name="0">
                    <el-form-item prop="phone">
                        <el-input v-model="registerForm.phone" :maxlength="11" type="text" size="large"  placeholder="请输入手机号" oninput="value=value.replace(/[^\d]/g,'')">
                            <template slot="prefix">
                                <i class="el-icon-user"/>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input class="input-code-padding" v-model="registerForm.code" :maxlength="6" type="text" size="large" placeholder="请输入短信验证码" oninput="value=value.replace(/[^\d]/g,'')">
                            <template slot="prefix">
                                <i class="el-icon-mobile-phone"/>
                            </template>
                            <template slot="suffix">
                                <el-button class="code-button" type="primary" size="large" :disabled="codeTime>0" @click="getCode"> {{codeTime === 0 ? '获取验证码' : codeTime + 's后获取'}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="registerForm.password" :maxlength="20" type="password" size="large" placeholder="请输入6~20位数字+字母组合密码" oninput="value=value.replace(/[\W]/g,'')">
                            <template slot="prefix">
                                <i class="el-icon-mobile-phone"/>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="againPassword">
                        <el-input v-model="registerForm.againPassword" :maxlength="20" type="password" size="large" placeholder="请再次输入新密码" oninput="value=value.replace(/[\W]/g,'')">
                            <template slot="prefix">
                                <i class="el-icon-mobile-phone"/>
                            </template>
                        </el-input>
                    </el-form-item>
                </el-tab-pane>
            </el-tabs>
            <el-form-item>
                <el-button class="submit-btn" type="primary" size="large"  @click="submitForm">立即重置</el-button>
            </el-form-item>
            <el-form-item>
                <el-button class="submit-btn" size="large" @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
        <verificationCode v-model="isImgCode" :phone="registerForm.phone" @close="isImgCode=false"/> 
    </div>
</template>

<script>
import mixin from './mixni/mixni.js'
import verificationCode from './components/verificationCode.vue'
import { validatePhone,isNumAndStr } from "@/utils/validate";
import { resetPassword } from '@/api/login'
export default {
    mixins: [mixin],
    components:{
        verificationCode
    },
    data() {
        const validatorMobile = (rule, value, callback) => {
            if (!validatePhone(value)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        const validatorPassword = (rule, value, callback) => {
            if (!isNumAndStr(value)) {
                callback(new Error("请输入6~20位数字+字母组合密码"));
            } else {
                callback();
            }
        };
        const validatorAgainPassword = (rule, value, callback) => {
            if (value!=this.registerForm.password) {
                callback(new Error("两次密码输入不一致！"));
            } else {
                callback();
            }
        };
        return {
            activeName: '0',
            registerForm: {
                phone: '',
                code:'',
                password:'',
                againPassword:''
            },
            registerRules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { validator: validatorMobile, trigger: "blur" }
                ],
                code: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入6~20位数字+字母组合密码', trigger: 'blur' },
                    { validator: validatorPassword, trigger: "blur" }
                ],
                againPassword: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    { validator: validatorAgainPassword, trigger: "blur" }
                ]
            },
            isImgCode:false,
        }
    },
    methods: {
        // 获取短信验证码
        getCode(){
            if(!this.registerForm.phone)return
            const obj = { phone : this.registerForm.phone, type : "sms_password" }
            this.getSmsCode(obj)
        },
        submitForm() {
            this.$refs.registerForm.validate((valid) => {
                if (valid) {
                    this.resetPassword()
                } else {
                    return false;
                }
            })
        },
        resetPassword(){
            resetPassword(this.registerForm).then(res=>{
                if(res.code==1){
                    this.$toast({
                        type: 'success',
                        message: '重置成功！',
                        duration: 2000
                    })
                    this.$emit('changeRegister')
                }   
            })
        },
        //取消   
        cancel(){
            this.$refs.registerForm.resetFields()
            this.$emit('changeRegister')
        }
    }
}
</script>
<style lang="scss" scoped>
.register-form{
    /deep/ .el-tabs{
        .el-tabs__item{
            color: #999999;
            font-size: 20px;
            &:hover{
                color: #333333; 
            }
        }
        .is-active{
            color: #333333; 
        }
        .el-tabs__nav-wrap::after{
            opacity: 0;
        }
    }
    /deep/ .el-form-item{
        margin-bottom: 25px;
        .el-form-item__content{
            .el-input__prefix{
                color: #333333;
                font-size: 18px;
                display: flex;
                align-items: center;
                left: 0.16rem;
                &::after{
                    content:'';
                    display: block;
                    width: 1px;
                    height: 50%;
                    margin-left: 10px;
                    background: #999999;
                }
                .el-input__icon{
                    line-height: 50px;
                }
            }
            .el-input__inner{
                height: 50px;
                font-size: 15px;
                padding-left: 60px;
            }
            .el-input__suffix{
                top:1px
            }
            .code-button{
                height: 48px;
                margin-right: -4px;
                border-radius: 0px 4px 4px 0;
            }
        }
        .submit-btn{
            width: 100%;
            height: 50px;
        } 
    } 
}
// 短信验证码 input padding值
.input-code-padding{
    .el-input__inner{
        padding-right: 150px;
    }
}
</style>